import styled from 'styled-components';

export const Title = styled.h3`
  font-size: 28px;
  font-weight: bold;
  color: #222;
  margin-bottom: 32px;
  text-align: center;
`;

export const Label = styled.label`
  font-weight: 600;
  color: #161641;
  font-size: 16px;
  display: block;
  margin-bottom: 8px;
`;

export const HelperText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #555;
  display: block;
  margin-top: 4px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 16px;
  border: 1px solid #141414;
  background: #f7f5f5;
  border-radius: 8px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.global.colors.primary};
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  padding: 8px 16px;
  border: 1px solid #141414;
  background: #f7f5f5;
  border-radius: 8px;
  resize: vertical;
  min-height: 90px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.global.colors.primary};
  }
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
`;

export const SubGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  flex-wrap: wrap;
`;

export const Error = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 4px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  margin-top: 40px;
`;

export const Button = styled.button`
  background-color: ${({ theme }) => theme.global.colors.primary};
  color: white;
  font-weight: bold;
  padding: 12px 24px;
  border-radius: 32px;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: #00b453;
  }
`;

export const AddButton = styled.button`
  background: none;
  color: ${({ theme }) => theme.global.colors.primary};
  font-weight: 600;
  font-size: 16px;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const HoursGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 32px;
  margin-top: 16px;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    grid-template-columns: 1fr;
  }
`;

export const BusinessHourRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  span {
    font-weight: bold;
    width: 30px;
  }

  input[type="checkbox"] {
    transform: scale(1.2);
    margin-right: 2px;
  }

  input[type="time"] {
    width: 110px;
    padding: 8px;
    border-radius: 6px;
    border: 1px solid #ccc;
    font-size: 14px;
    background: #f8f8f8;
  }

  span.separator {
    font-weight: normal;
    margin: 0 2px;
  }
`;

export const Grid2 = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px 24px;

  @media ${({ theme }) => theme.global.mediaQueries.lg} {
    grid-template-columns: 1fr;
  }
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 32px;
  margin-top: 10px;

  label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
  }
`;
export const Centered = styled.div`
  text-align: center;
  max-width: 720px;
  margin: 0 auto;
`;

export const Paragraph = styled.p`
  color: #333;
  font-size: 16px;
  line-height: 1.6;
`;

export const Icon = styled.img`
  width: 52px;
  height: 52px;
  margin-bottom: 24px;
`;